export enum DashboardTabs {
    SalesOrders = 'sales-orders',
    Inquiries = 'inquiries',
    PurchaseOrders = 'purchase-orders',
    Demands = 'demands',
    Invoices = 'invoices',
}
